﻿import { Component, ElementRef, EventEmitter, Input, Output, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { DataTable } from "angular2-datatable";
import { DataService } from "../services/dataService";
import { ValidationBase } from "../validation/validationBase";
import { ValidationMessage } from "../validation/validationMessage";
import { ValidationMessageType } from "../validation/validationMessageType";
import { EmailValidator } from "../validation/validators/emailValidator";
import { ValidatorTuple } from "../validation/validators/iValidator";
import { PhoneValidator } from "../validation/validators/phoneValidator";
import {  Departments } from '../models/Enums';





@Component({
    selector: "jax-myprofilecomponent",
    templateUrl: "./myprofile.component.html"
})

export class MyProfileComponent extends ValidationBase {
    public iNotifyError;
    public emailValidators = [];
    public phoneValidators = [];
    public isCustomValid: boolean;
    public myprofile: any = {};
    private getuser: any;
    private loginName: any;
    private currentUser: any;
    public totalRecord = 0;
    public isCompleted = false;
    public validationMessage: ValidationMessage;
    public passwordRuledescription: string;
    public hasSuccess:boolean;




    public emailhasError: boolean;
    public phonehasError: number;
    public supervisorhasError: boolean;


    constructor(private dataService: DataService, private router: Router) {
        super();
        this.emailValidators.push(new ValidatorTuple(new EmailValidator(), this));
        this.phoneValidators.push(new ValidatorTuple(new PhoneValidator(), this));
        this.iNotifyError = this;

    }

    public ngOnInit() {
        this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
        if (this.currentUser) {
            this.loginName = this.currentUser.LoginName;
        }

        this.isCompleted = false;
        this.dataService.get("User/getuser?LoginName=" + this.currentUser.LoginName).subscribe(
            (resp) => {
                this.myprofile = resp;
                this.myprofile.NewEmailAddress = this.myprofile.EmailAddress;
                this.myprofile.NewPhoneNumber = this.myprofile.PhoneNumber;
                this.myprofile.NewSupervisor = this.myprofile.Supervisor;
                this.isCompleted = true;
            },
            (error) => {
                this.validationMessage = error.message;
                this.isCompleted = true;
            });

        this.passwordRuledescription = "<b>Your password must be at least 8 characters long and include at least 3 of these elements.</b><ul>"
        this.passwordRuledescription = this.passwordRuledescription + "<li>Uppercase</li><li>Lowercase</li><li>Numbers</li><li>Special Character(!@$* _ -)</li></ul";
        this.passwordRuledescription = this.passwordRuledescription +
            "<br/><br/>New password cannot be one of your last 10 passwords";
    }

    public clearSubmit() {
        this.myprofile.NewEmailAddress = this.myprofile.EmailAddress;
        this.myprofile.NewPhoneNumber = this.myprofile.PhoneNumber;
        this.myprofile.NewSupervisor = this.myprofile.Supervisor;
        this.validate();
    }

    private phoneFormat() {
        if (this.myprofile.NewPhoneNumber) {
            if (!isNaN(this.myprofile.NewPhoneNumber)) {
                this.myprofile.NewPhoneNumber = this.myprofile.NewPhoneNumber.substring(0, 3) + "-" + this.myprofile.NewPhoneNumber.substring(3, 6) + "-" + this.myprofile.NewPhoneNumber.substring(6, 10);
            }
            else {
                this.myprofile.NewPhoneNumber = this.myprofile.NewPhoneNumber.replace(")-", ") ");
            }
        }
    }

       private IsValidDCSEmail() {
        let emailId = this.myprofile.NewEmailAddress;
        if (!emailId) {
            return true;
        }

        let emailDomain = emailId.substring(emailId.indexOf('@') + 1);
        if (this.currentUser.Department != Departments.DCS || (this.currentUser.Department == Departments.DCS && (emailDomain.toUpperCase() == 'AZDCS.GOV'))) {
            return true;
        } else {

            let msg = new ValidationMessage();
            msg.messageType = ValidationMessageType.Error;
            msg.message = "Please use valid official email";
            this.validationMessage = msg;

            return false;
        }
    }

    public submit() {

        if (!this.myprofile.NewEmailAddress && !this.myprofile.NewPhoneNumber && !this.myprofile.NewSupervisor) {
            let msg = new ValidationMessage();
            msg.messageType = ValidationMessageType.Error;
            msg.message = "There are no changes";
            this.validationMessage = msg;
            return;
        }

        this.validate()
        .subscribe((s) => {
            if (!this.isValid || !this.IsValidDCSEmail()) {
                return;
            }

            this.validationMessage = null;
            let message = new ValidationMessage();

                this.myprofile.UserId = this.currentUser.UserId;
                this.phoneFormat();
                this.dataService.post("User/profile", JSON.stringify(this.myprofile))
                    .subscribe((response) => {
                        if (response.Succeeded == 1) {
                            this.hasSuccess = true;
                            message.messageType = ValidationMessageType.Ok;
                        } else {
                            this.hasSuccess = false;
                            message.messageType = ValidationMessageType.Error;
                        }
                        message.message = response.Message;
                        this.validationMessage = message;
                    },
                        error => {
                            this.hasSuccess = false;
                            message.message = error.message || error.message.Message;
                            message.messageType = ValidationMessageType.Error;
                            this.validationMessage = message;
                        });

        });
    }
}